var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPencilPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-pencil",
    clipPath: "url(#clip0_2888_4017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.781333 12.7449C0.281202 13.2449 0.000151033 13.9231 0 14.6303L0 15.9989H1.36867C2.07585 15.9988 2.75402 15.7177 3.254 15.2176L12.1493 6.32227L9.67667 3.84961L0.781333 12.7449Z",
    fill: "#735BF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4298 0.569262C15.2675 0.406753 15.0747 0.277833 14.8625 0.189874C14.6503 0.101914 14.4228 0.0566406 14.1931 0.0566406C13.9634 0.0566406 13.736 0.101914 13.5238 0.189874C13.3116 0.277833 13.1188 0.406753 12.9565 0.569262L10.6191 2.90726L13.0918 5.37993L15.4298 3.0426C15.5923 2.88026 15.7212 2.68748 15.8092 2.47528C15.8972 2.26308 15.9424 2.03563 15.9424 1.80593C15.9424 1.57623 15.8972 1.34877 15.8092 1.13658C15.7212 0.924382 15.5923 0.731603 15.4298 0.569262Z",
    fill: "#735BF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2888_4017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencilPrimary);
export default __webpack_public_path__ + "static/media/iconPencilPrimary.d3cdb598ad1016f9e5fde99a2910ae61.svg";
export { ForwardRef as ReactComponent };